module.exports = __webpack_public_path__ + "img/nico.9ea30bf4.jpg";